import {Code} from '@tiptap/extension-code';
import {InputRule, markInputRule} from '@tiptap/core';

import appPostStyles from '../app-post-style.module.css';
import {clearFormatStoredMarks} from '../utils';

const inputCodeRegex = /(^|[^`])`(?!\s+`)([^`]+)`(?!`)\s$/;

function codeInputRule(config: Parameters<typeof markInputRule>[0]) {
    const defaultMarkInputRule = markInputRule(config);

    return new InputRule({
        find: config.find,
        handler(props) {
            const fullMatch = props.match[0]!;
            const startChars = fullMatch.search('`');

            if (startChars > 0) {
                // markInputRule умеет корректно обрабатывать только пробелы в начале fullMatch
                // Если эту замену не сделать, то при вводе "is`code`" получим "i<code>code</code>" (потеряли "s")
                // В будущих обновлениях tiptap скорее всего это исправят
                props.match[0] = ' '.repeat(startChars) + props.match[0].slice(startChars);
            }

            defaultMarkInputRule.handler(props);
            clearFormatStoredMarks(props.state);
        },
    });
}

export const TimeWebkitCodeExtension = Code.extend({
    excludes: '',
    addInputRules() {
        return [
            codeInputRule({
                find: inputCodeRegex,
                type: this.type,
            }),
        ];
    },
}).configure({HTMLAttributes: {class: appPostStyles.code}});
